import { CmProAuthService } from "./cmpro-auth.service";
import { JsonApiService } from "./json-api.service";
import { NotificationService } from "./notification.service";
import { LayoutService } from "./layout.service";

export const services = [
  CmProAuthService,
  JsonApiService,
  NotificationService,
  LayoutService,

];

export * from "./cmpro-auth.service";
export * from "./json-api.service";
export * from "./notification.service";
export * from "./layout.service";

